module.exports = __webpack_public_path__ + "img/10.aef49c18.png";